function CorporateRate() {
    return (
      <>
        <div className="font-bold text-lg mb-16">CorporateRate</div>
      </>
    );
  }
  
  export default CorporateRate;